/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import App from './App.vue'

// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css'; // Vuesax
Vue.use(Vuesax)


// axios
//import axios from "./axios.js"
//Vue.prototype.$http = axios

// Theme Configurations
import '../themeConfig.js'

// Globally Registered Components
import './globalComponents.js'


// Styles: SCSS
import './assets/scss/main.scss'


// Tailwind
//import '@/assets/css/main.css'
import './assets/css/main.css'

// Vue Router
import router from './router'


// Vuex Store
import store from './store/store'


// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from 'vue2-hammer'
Vue.use(VueHammer)


// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'


// Feather font icon
require('./assets/css/iconfont.css')

// VeeValidate
import VeeValidate from 'vee-validate';
Vue.use(VeeValidate);

import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: '/loading/loading-2.gif',
  loading: '/loading/loading-2.gif',
  attempt: 1
})

//Font Awesome
import {fas} from '@fortawesome/free-solid-svg-icons'
import {far} from '@fortawesome/free-regular-svg-icons'
import {library} from '@fortawesome/fontawesome-svg-core'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'

Vue.component('font-awesome-icon', FontAwesomeIcon)
library.add(fas,far)
Vue.config.productionTip = false


import VueTheMask from 'vue-the-mask'
Vue.use(VueTheMask)


import VueCurrencyInput from 'vue-currency-input'
Vue.use(VueCurrencyInput)


import VueGoodTablePlugin from 'vue-good-table';

// import the styles
import 'vue-good-table/dist/vue-good-table.css'

Vue.use(VueGoodTablePlugin);


import {baseApiUrl } from "@/global";

/*
import VueSocketIO from 'vue-socket.io'
Vue.use(new VueSocketIO({
  // debug: true
  connection: baseApiUrl,
  vuex: {
      store,
      actionPrefix: 'SOCKET_',
      mutationPrefix: 'SOCKET_'
  },
}))*/

import Skeleton from 'vue-loading-skeleton';
Vue.use(Skeleton);

import _ from 'lodash'

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
